import { Link, useNavigate } from "react-router-dom";
import { Star, Download, ArrowRight } from "lucide-react";
import { formatIDR, mediaUrl, typeLabel } from "../lib/format";

export function ProductCard({ p }) {
  const navigate = useNavigate();
  return (
    <div
      data-testid={`product-card-${p.id}`}
      onClick={() => navigate(`/products/${p.slug}`)}
      className="group cursor-pointer rounded-xl border border-slate-200/80 bg-white hover:border-indigo-300 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 overflow-hidden flex flex-col"
    >
      <div className="relative aspect-video bg-slate-100 overflow-hidden">
        <img src={mediaUrl(p.thumbnail)} alt={p.title} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300" />
        <div className="absolute top-2.5 left-2.5 flex gap-1.5">
          {p.is_new && <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">NEW</span>}
          {p.is_popular && <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 border border-amber-200">POPULER</span>}
        </div>
        <span className="absolute bottom-2.5 right-2.5 text-[10px] font-bold px-2 py-0.5 rounded-full bg-slate-900/80 text-white">{typeLabel(p.product_type)}</span>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <p className="text-[11px] font-semibold text-indigo-600 uppercase tracking-wider mb-1">{p.category_name}</p>
        <h3 className="font-heading font-bold text-slate-900 line-clamp-1 mb-1.5">{p.title}</h3>
        <p className="text-xs text-slate-500 line-clamp-2 mb-3 flex-1">{p.short_description}</p>
        <div className="flex flex-wrap gap-1 mb-3">
          {(p.technology || []).slice(0, 3).map((t) => (
            <span key={t} className="text-[10px] font-mono px-1.5 py-0.5 rounded bg-slate-100 text-slate-600 border border-slate-200">{t}</span>
          ))}
        </div>
        <div className="flex items-center justify-between text-xs text-slate-500 mb-3">
          <span className="flex items-center gap-1"><Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" /> {p.rating}</span>
          <span className="flex items-center gap-1"><Download className="h-3.5 w-3.5" /> {p.download_count}</span>
        </div>
        <div className="flex items-center justify-between border-t border-slate-100 pt-3">
          <span className={`font-heading font-bold ${p.price === 0 ? "text-emerald-600" : "text-slate-900"}`}>{formatIDR(p.price)}</span>
          <span className="flex items-center gap-1 text-sm font-semibold text-indigo-600 group-hover:gap-2 transition-all">
            Detail <ArrowRight className="h-4 w-4" />
          </span>
        </div>
      </div>
    </div>
  );
}

export function ProductCardSkeleton() {
  return (
    <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
      <div className="aspect-video skeleton" />
      <div className="p-4 space-y-3">
        <div className="h-3 w-20 skeleton rounded" />
        <div className="h-4 w-3/4 skeleton rounded" />
        <div className="h-3 w-full skeleton rounded" />
        <div className="h-8 w-full skeleton rounded" />
      </div>
    </div>
  );
}
